import { render, staticRenderFns } from "./custom-bread-crumb.vue?vue&type=template&id=4a833eda"
import script from "./custom-bread-crumb.vue?vue&type=script&lang=ts"
export * from "./custom-bread-crumb.vue?vue&type=script&lang=ts"
import style0 from "./custom-bread-crumb.vue?vue&type=style&index=0&id=4a833eda&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports